import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { isMobileDevice } from 'lib/device'
import { setSuggestToOpenAppActive } from 'store/actions/uiState'

export const useRedirectToApp = (referrer?: string) => {
  const dispatch = useDispatch()
  useEffect(() => {
    if (!referrer) {
      return
    }

    // if redirect from twitter and is mobile device
    if (referrer.startsWith('https://t.co') && isMobileDevice) {
      dispatch(setSuggestToOpenAppActive(true))
    }
  }, [referrer])
}
